import './newsletter.css';
import md5 from 'md5';

export const NewsletterView = Backbone.View.extend({
  el: $('#js-footer'),

  initialize: function () {
    const that = this;
    this.$newsletterForm = $('.js-newsletterContainer');
    this.$newsletterForm.each((i, item) => {
      that.initNewsletterForm($(item));
    });
  },

  initNewsletterForm: function ($form) {
    const $inputContainer = $form.find('.inputContainer'),
      $mdlTextfield = $form.find('.mdl-textfield'),
      $newsletterEmailInput = $form.find('input[id$="newsletter_email"].mdl-textfield__input'),
      $newsletterEmail = $form.find('input[id$="newsletter_email"]'),
      $newsletterValidation = $form.find('.js-newsletterValidation'),
      validClass = 'is-valid',
      invalidClass = 'is-invalid',
      buttonLoaderClass = 'buttonLoader',
      isFocused = 'is-focused';

    $newsletterEmailInput.on('input keyup click blur', function (e) {
      $inputContainer.removeClass(validClass).addClass(invalidClass);
      if ($mdlTextfield.hasClass(isFocused)) {
        $inputContainer.removeClass(invalidClass);
      }
      if (!$mdlTextfield.hasClass(invalidClass) && $newsletterEmailInput.val().length > 1) {
        $inputContainer.addClass(validClass).removeClass(invalidClass);
      }
      setTimeout(() => {
        if (!$mdlTextfield.hasClass(isFocused) && $mdlTextfield.hasClass(invalidClass) && $newsletterEmail.val().length > 1) {
          $inputContainer.addClass(invalidClass);
        }
      }, 100);
    });

    //sur la validation du formulaire, envoi d'une requete ajax avec l'email de l'utilisateur
    $newsletterValidation.on('click', event => {
      event.preventDefault();
      const trackingData = $form.find('.js-newsletterValidation').data('tracking');
      let isOnerror = true;

      if ($newsletterEmail.val() !== '') {
        if (!$mdlTextfield.hasClass(invalidClass) && !!$newsletterEmailInput.val()) {
          isOnerror = false;
          this.emailValidation($form);
        } else {
          $inputContainer.addClass(invalidClass);
          $newsletterValidation.removeClass(buttonLoaderClass);
        }
      } else {
        $newsletterValidation.removeClass(buttonLoaderClass);
        $inputContainer.addClass(invalidClass);
      }
      if (isOnerror) {
        /*
          The variable 'gaLabel' is used to distinguish between two types of forms:
          - 'register': This label is used for the leadgen popin form.
          - 'validation': This label is assigned to the footer newsletter form .
        */
        if (trackingData.gaLabel.includes('register')) {
          Tracking.dataLayerPush(trackingData);
        } else {
          this.handleClickTracking(true);
        }


        setTimeout(function () {
          button.clearButtonLoader();
        }, 200);
      }
    });

    $form.on('submit', (event) => {
      event.preventDefault();
      this.emailValidation($form);
    });

    if ($form.find('#footer-newsletterForm').length) {
      let displayTracking = true;

      $(window).on('scroll', () => {
        if (displayTracking && window.checkIf$ElemInViewport($('#footer-newsletterForm'))) {
          Tracking.dataLayerPush({
            event: 'element_displayed',
            gaCategory: 'Lead gen',
            gaAction: 'newsletterForm Footer',
            gaLabel: 'newsletter block display'
          });
          displayTracking = false;
        }
      });
    }
  },

  handleClickTracking: function (isError = false) {
    Tracking.dataLayerPush({
      event: 'clickEvent',
      gaCategory: 'Lead gen',
      gaAction: 'newsletterForm Footer',
      gaLabel: `Click - ${isError ? 'Invalid form' : 'Valid form'}`
    });
  },

  emailValidation: function ($form) {
    const formName = $form.attr('name');
    const value = $form.find('input[id$="newsletter_email"]').val();
    const $emailField = $form.find('.mdl-js-textfield');
    const trackingData = $form.find('.js-newsletterValidation').data('tracking');
    const isLeadGen = $form.parents('.leadGen').length;

    // Used for tracking error
    let isError = false;

    //gestion erreur
    if (!$form.find('.mdl-js-textfield').hasClass('is-invalid') && value !== '') {

      if (typeof (trackingData.formIsConfirmation) !== 'undefined') {
        trackingData.formIsConfirmation = true;
      } else {
        trackingData.gaLabel = 'register';
      }

      const successCallback = data => {
        const wordings = GLOBAL_SCRIPTS.WORDING_NEWSLETTER;

        if (data.status === 'success') {
          const text = `<p class="NewsletterConfirm"><i class="icon icon-newsletters_ok"></i><strong class="NewsletterConfirm-title">${isLeadGen ? wordings.news_lateral_form_confirm_1 : wordings.news_form_confirm_1}</strong><br>${isLeadGen ? wordings.news_lateral_form_confirm_2 : wordings.news_form_confirm_2} ${isLeadGen ? `<br><br><a class="js-buttonLoader buttonContainer js-newsletterClose newsletter-close"><span class="button button--greenWhite">${wordings.news_lateral_form_close}</span></a>` : ''}</p>`;

          $form.html(text);
        } else if (data.status === 'user_exist') {
          const text = `<p class='NewsletterConfirm'><i class='icon icon-newsletters_ok'></i><strong class='NewsletterConfirm-title' >${wordings.news_form_user_exist_1}</strong>${wordings.news_form_user_exist_2}</p>`;

          $form.html(text);
        } else {
          button.clearButtonLoader();
        }

        if (cookieManagement.getCookie('cookieNewsletter') === null) {
          //memorizing newsletter form status in a cookie, only if there's no error
          cookieManagement.createCookie('cookieNewsletter', 1, 365);
        }
      };

      if (value !== '') {
        const ajaxParams = {
          email: value,
          univers: GLOBAL_SCRIPTS.UNIVERS_ID,
          language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
          country: GLOBAL_SCRIPTS.MARKET_CODE,
          brand: GLOBAL_SCRIPTS.UNIVERS === 'sp' ? 'sp' : 'cp'
        };

        //détermination des paramètres à utiliser pour l'inscription à la newsletter
        const ajaxData = {
          ajaxUrl: $form.find('form[action]').attr('action'),
          ajaxParams: ajaxParams,
          successCallback: successCallback,
          abortable: true,
          origin: 'newsletterForm',
          dataType: 'json',
          type: 'POST'
        };

        const resultPromise = genericAjaxCall(ajaxData);

        resultPromise.then(_ => {
          button.clearButtonLoader();
        }).catch(error => {
          if (error.status === 200) {
            button.clearButtonLoader();
          }
        });
      }
    } else {
      button.clearButtonLoader();

      // gestion du tracking error
      isError = true;

      if (typeof (trackingData.formIsConfirmation) !== 'undefined') {
        trackingData.formName = formName;
        trackingData.formIsInError = true;
        trackingData.formErrorType = [{
          'errorField': 'newsletter_email',
          'errorMessage': $emailField.hasClass('is-invalid') ? 'email invalide' : 'email vide'
        }];
        trackingData.event = 'trackErrorForm';
        trackingData.gaLabel = 'error';
      }
    }

    if (typeof (trackingData.formIsConfirmation) !== typeof undefined) {
      trackingData.email = md5(value);
    }

    // Tracks click events for the newsletter form in the footer.
    // Refer to the comment on line 59 for details on distinguishing this form.
    if (!trackingData.gaLabel.includes('register')) {
      this.handleClickTracking(isError);
    }

    // Rule : we push tracking datas only if the newsletter cookie is not
    if ((cookieManagement.getCookie('cookieNewsletter') === null && !!trackingData.formIsConfirmation) || trackingData.gaLabel.includes('register')) {
      Tracking.dataLayerPush(trackingData);
    }
  }
});